<template>
  <div>
    <v-row align="center" justify="center">
      <v-col cols="12" sm="8" md="4">
        <v-card class="elevation-12">
          <v-toolbar class="primary white--text" >
            <v-toolbar-title >Вход в личный кабинет</v-toolbar-title>
            <div :style="{justifyContent: 'end',display: 'flex', width: '100%', height: 64, overflow: 'hidden'}">
              <div :style="{backgroundColor: '#FFFFFF', display: 'flex', alignItems: 'center', justifyContent: 'center', borderRadius: '5px'}">
              <img src="https://finexpert.pro/assets/finexp/images/logo.svg" alt="logo" height="50">
            </div>
            </div>

          </v-toolbar>
          <v-card-text>
            <v-form ref="form" v-model="valid" lazy-validation>
              <v-text-field
                v-model="email"
                prepend-icon="email"
                :rules="rules.emailRules"
                required
                label="Email адрес"
                type="email"
              ></v-text-field>

              <v-text-field
                v-model="password"
                :rules="rules.passwordRules"
                required
                id="password"
                counter="16"
                :append-icon="show ? 'visibility_off' : 'visibility'"
                @click:append="show = !show"
                :type="show ? 'text' : 'password'"
                prepend-icon="lock"
                name="password"
                label="Пароль"
              ></v-text-field>
            </v-form>
          </v-card-text>
          <v-card-actions>
            <a class="bluelink pl8" @click.prevent="passwordRecovery"
              >Восстановить пароль</a
            >
            <v-spacer></v-spacer>

            <v-btn v-if="1 == 2" type="checker" @click="check">Отладка</v-btn>
            <v-btn type="submit" :disabled="!valid || enabledLog" @click="Login"
              >Войти</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>


<script>
import Globalrules from "../components/api/rules.js";
import Swal from "sweetalert2";
export default {
  data() {
    return {
      rules: Globalrules,
      valid: true,
      show: false,
      email: "",
      password: "",
      someError: "",
    };
  },
  computed: {
    error() {
      return this.$store.getters.getError;
    },
    enabledLog() {
      return this.$store.getters.getProcessing;
    },
  },
  methods: {
    debug(offset) {
      var today = new Date();
      var year = today.getFullYear();
      var month = today.getMonth();
      var day = today.getDay();
      var hours = today.getHours();
      var minutes = today.getMinutes();

      var d = new Date(Date.UTC(year, month, day, hours, minutes, 0));

      d.setHours(d.getHours() + offset - 3);
      var hh = d.getHours();
      var mm = d.getMinutes();
      if (hh < 10) hh = "0" + hh;
      if (mm < 10) mm = "0" + mm;
      return " " + hh + ":" + mm + " ";
    },
    passwordRecovery() {
      this.$router.push("/passwordrecovery");
    },
    Login() {
      var data = {
        email: this.email,
        password: this.password,
        remember_me: 1,
      };
      if (this.$refs.form.validate()) {
        this.$store
          .dispatch("SIGNIN", data)
          .then((res) => {
            if (res.data.error == "BLOCKED") {
              if (res.data.inn == "505203230884") {
                // Щелкунов
                // if(res.data.inn == '6324003370'){ //Эфективные Технологии
                Swal.fire({
                  icon: "error",
                  title: "Доступ в личный кабинет заблокирован.",
                  html: `По вопросу восстановления доступа обратитесь к директору чата. Также вы можете создать обращение в техподдержку Сервиса по почте help@finexpert.pro`,
                    // <a href='https://t.me/bankagent_bot' target='_blank' >
                    //   <button type="button" class="swal2-confirm swal2-styled" aria-label="" style="text-decoration: none; display: inline-block; border-left-color: rgb(48, 133, 214); border-right-color: rgb(48, 133, 214); color: white;">
                    //   Перейти</button></a> <br><br> или по ссылке <a href='https://t.me/bankagent_bot' target='_blank' >https://t.me/bankagent_bot</a>`,
                  showCancelButton: true,
                  cancelButtonText: "Понятно",
                  showConfirmButton: false,
                }).then((result) => {
                  // if (result.isConfirmed) {
                  //   const btn = document.createElement('a')
                  //   btn.setAttribute('href','https://t.me/bankagent_bot')
                  //   btn.setAttribute('target', '_blank')
                  //   btn.click()
                  // } //else if (result.isDenied) {
                  //   Swal.fire('Changes are not saved', '', 'info')
                  // }
                });
                return;
              }
              if(res.data.JurIPSam === 'Jur'){
                Swal.fire({
                  icon: "error",
                  title: "Доступ в личный кабинет заблокирован.",
                  text: "Для восстановления доступа обратитесь к руководителю вашей компании. Также вы можете создать обращение в техподдержку Сервиса по почте help@finexpert.pro",
                  showCancelButton: true,
                  cancelButtonText: "Понятно",
                  showConfirmButton: false,
                });
                return;
              }
              if(res.data.JurIPSam === 'IP'){
                Swal.fire({
                  icon: "error",
                  title: "Доступ в личный кабинет заблокирован.",
                  text: "Для восстановления доступа обратитесь к своему руководителю. Также вы можете создать обращение в техподдержку Сервиса по почте help@finexpert.pro",
                  showCancelButton: true,
                  cancelButtonText: "Понятно",
                  showConfirmButton: false,
                });
                return;
              }
              if(res.data.JurIPSam === 'SZ'){
                Swal.fire({
                  icon: "error",
                  title: "Доступ в личный кабинет заблокирован.",
                  text: "Вы можете создать обращение в техподдержку Сервиса по почте help@finexpert.pro",
                  showCancelButton: true,
                  cancelButtonText: "Понятно",
                  showConfirmButton: false,
                });
                return;
              }

            }
            if (res.data.error == "DISABLED") {
              Swal.fire({
                icon: "error",
                title: "Пользователь не активирован",
                text:
                  "Активируйте его через отправленное вам на email письмо или обратитесь в службу поддержки.",
              });
              return;
            }
            if (res.data.error == "NOROLE") {
              Swal.fire({
                icon: "error",
                title: "",
                text:
                  "Для работы в личном кабинете сервиса finexpert.pro вам необходимо связаться с администратором Вашей организации. На почту сотрудника с полномочиями администратора уже выслана информация для присвоения вам роли в сервисе. Если вы являетесь руководителем данной организации, вы можете обратиться в техническую поддержку по почте help@finexpert.pro",
              });
              return;
            }
            if (res.data.error == "Unauthorized") {
              this.err = res.data.message;
              Swal.fire({
                icon: "error",
                title: "Ошибка входа в систему",
                text: "Проверьте имя пользователя или пароль",
              });
              return;
            }


            // const newUrl = localStorage.getItem('url')!== undefined && localStorage.getItem('url')!== null && localStorage.getItem('url')!== '/404' ? localStorage.getItem('url') : res.data.redirect

            // this.$router.push(newUrl)
            location.reload();
          })

      }
    },
    check() {
      this.$store.dispatch("DEBUG").then(() => {});
    },
  },
  mounted() {
    this.setTitle("Вход");
  },
};
</script>

<style lang="scss">
.pl8 {
  padding-left: 8px;
}
</style>
